import type { ExtraLayoutRendererProps } from '../../../components/Navigator/layoutRenderers/CollapsedLayoutRenderer'
import type { DriverChip } from '../../../components/Navigator/typings'

import { useCallback } from 'react'

import { Stack } from '@mui/material'

import { Navigator } from '../../../components/Navigator'
import CollapsedLayoutRenderer from '../../../components/Navigator/layoutRenderers/CollapsedLayoutRenderer'

import { useDriversNavigator } from '../hooks/useDriversNavigator'
import { DriverItemRenderer } from './DriverItemRenderer'

const renderProps: ExtraLayoutRendererProps = {
  chipShape: 'rounded',
}

export function DriversNavigator() {
  const { chips, page, setPage } = useDriversNavigator()

  const onChangeIndex = useCallback(index => setPage(index), [setPage])

  return (
    <Stack
      direction="column"
      data-trackid="navigo-drivers-navigator"
      data-testid="navigo-drivers-navigator"
      justifyContent="center"
      width="auto"
      height="100%"
      flexShrink={0}
    >
      <Navigator<DriverChip, ExtraLayoutRendererProps, Record<string, any>>
        items={chips}
        selectedIndex={page}
        onChangeIndex={onChangeIndex}
        ItemRenderer={DriverItemRenderer}
        extraItemRendererProps={renderProps}
        extraLayoutRendererProps={renderProps}
        LayoutRenderer={CollapsedLayoutRenderer}
      />
    </Stack>
  )
}
